import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { BookingService } from '../service/booking.service';
import { HttpService } from '../service/http.service';
import { PaymentReceived } from '../payment-received';
import { PaymentReceivedService } from '../service/payment-received.service';
import { ToastMessageService } from '../toast-message.service';
import { DecimalValidator } from '../validator/decimal-validator';
import { NumberValidator } from '../validator/number-validator';
import { CurrencyService } from '../service/currency.service';
import { BookingTransactionsService } from '../service/booking-transactions.service';
import { UserService } from '../service/user.service';

@Component({
  selector: 'app-create-payment-received',
  templateUrl: './create-payment-received.component.html',
  styleUrls: ['./create-payment-received.component.css']
})
export class CreatePaymentReceivedComponent implements OnInit {

  paymentForm!: FormGroup;
  submitFail = false;
  invalidAmount = false;
  isSubmitting = false;

  @Output() newPaymentReceived = new EventEmitter<any>();

  public FINANCE = "financial_encoder";
  public isFinancialEncoder = this.userService.hasRole(this.FINANCE);

  constructor(
    private httpService: HttpService,
    private builder: FormBuilder,
    public bookingService: BookingService,
    private toastService: ToastMessageService,
    public paymentReceivedService: PaymentReceivedService,
    public currencyService: CurrencyService,
    public bookingTransactionsService: BookingTransactionsService,
    private userService: UserService
  ) { }

  ngOnInit(): void {
    let isFinancialRecord = this.isFinancialEncoder;
    this.paymentForm = this.builder.group({
      amount: [0, Validators.compose([DecimalValidator, NumberValidator])],
      currency: this.currencyService.currencies[0],
      date: [new Date(), Validators.required],
      paymentType: [this.bookingService.paymentTypes[0], Validators.required],
      comment: null,
      invoiceNumber: null,
      isFinancialRecord: isFinancialRecord
    });
  }

  submit(){
    this.submitFail = false;
    this.isSubmitting = true;
    if(this.paymentForm.invalid){
      this.toastService.addError("Error", "Form is not complated correctly.");
      this.submitFail = true;
      this.isSubmitting = false;
      return;
    }
    let payment = new PaymentReceived(
      this.paymentForm.value.comment,
      moment(this.paymentForm.value.date).utc(true),
      this.paymentForm.value.amount,
      this.paymentForm.value.paymentType, 
      this.paymentForm.value.invoiceNumber,
      this.paymentForm.value.currency,
      this.paymentForm.value.isFinancialRecord
    );
    this.httpService.postPaymentReceived(payment, this.bookingService.booking.id!).subscribe(() => {
      this.isSubmitting = false;
      this.newPaymentReceived.emit(null);
      this.bookingTransactionsService.updateTransactions();
      this.bookingService.updateCompletePaymentDate();
    });
  }

  amountChange(event: any){
    let value = event.target.value as string;
    if(value.includes(",")){
      value = value.replaceAll(",", ".");
      event.target.value = value;
    }
  }

}
